import { createSingleRecordReadOnlyApi } from '@skylabs-digital/react-proto-kit';
import { metricsSummarySchema } from '../schemas/metrics.schema';

export type { ChannelMetrics, MetricsSummary } from '../schemas/metrics.schema';

export const metricsApi = createSingleRecordReadOnlyApi('metrics/summary', metricsSummarySchema);
